export const support = {
  title: "Support",
  subtitle: "Get help from our support team",
  tickets: {
    title: "Tickets",
    create: "Create Ticket",
    status: {
      OPEN: "Open",
      IN_PROGRESS: "In Progress",
      RESOLVED: "Resolved",
      CLOSED: "Closed",
    },
    priority: {
      LOW: "Low",
      MEDIUM: "Medium",
      HIGH: "High",
      URGENT: "Urgent",
    },
    table: {
      title: "Title",
      status: "Status",
      client: "Client",
      priority: "Priority",
      createdAt: "Created At",
      lastUpdate: "Last Update",
      actions: "Actions",
    },
    actions: {
      view: "View",
      reply: "Reply",
      close: "Close",
      changePriority: "Change Priority",
    },
    modal: {
      title: "New Ticket",
      titleLabel: "Briefly describe your issue or question",
      titlePlaceholder: "Briefly describe your issue or question",
      descriptionLabel: "Describe your issue or question in detail",
      descriptionPlaceholder: "Describe your issue or question in detail",
      priorityLabel: "Priority",
      priority: {
        low: "Low",
        medium: "Medium",
        high: "High",
        urgent: "Urgent",
      },
      submit: "Submit",
    },
  },
  detail: {
    description: "Description",
    conversation: "Conversation",
    created: "Created at {{date}}",
    replyPlaceholder: "Write your reply here",
    user: "You",
    staff: "Staff",
    send: "Send",
    success: {
      messageSent: "Message sent successfully",
    },
    error: {
      loading: "Error loading ticket",
      sending: "Error sending message",
    },
  },
};
